import * as React from "react";
import { IReservationSidebarContext } from "../Types";

export const ReservationSidebarContext = React.createContext<IReservationSidebarContext>({} as IReservationSidebarContext);
ReservationSidebarContext.displayName = 'Reservation sidebar context';

export function useReservationSidebarContext() {
  return React.useContext(ReservationSidebarContext);
}